/**
 * Created by Jerker Nord on 2023-09-25.
 */
import {Loner} from "../../../Loner";
import {LonerGameAssets} from "../../../LonerGameAssets";
import {gsap, Linear} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class LonerSkyScroller extends PIXI.Container {

    private static SKY_POSITIONS: PIXI.Point[] = [new PIXI.Point(0, 0), new PIXI.Point(302, 0), new PIXI.Point(604, 0), new PIXI.Point(906, 0)];

    private _skyTextures: PIXI.Texture[];
    private _scrollContainer01: PIXI.Container;
    private _scrollContainer02: PIXI.Container;
    private _scrollContainer01TextureNumber: number[];
    private _scrollContainer02TextureNumber: number[];
    private _scrollContainer01Sprites: PIXI.Sprite[];
    private _scrollContainer02Sprites: PIXI.Sprite[];
    private _skyTextureWidth: number;
    private _scroll01TL: gsap.core.Timeline;
    private _scroll02TL: gsap.core.Timeline;

    constructor() {
        super();
        this.init();
    }

    private init(): void {
        this._skyTextures = [];
        this._skyTextures.push(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SKY_CLOUD_01)[0]);
        this._skyTextures.push(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SKY_CLOUD_02)[0]);
        this._skyTextures.push(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SKY_NO_CLOUD)[0]);
        this._skyTextures.push(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SKY_NO_CLOUD)[0]);
        this._skyTextures.push(Loner.assetLoader.getTextures(LonerGameAssets.TTB_SKY_NO_CLOUD)[0]);

        this._skyTextureWidth = this._skyTextures[0].width;
        this._skyTextureWidth -= 2;

        this._scrollContainer01 = new PIXI.Container();
        this._scrollContainer02 = new PIXI.Container();
        this._scrollContainer01TextureNumber = [];
        this._scrollContainer02TextureNumber = [];
        this._scrollContainer01Sprites = [];
        this._scrollContainer02Sprites = [];
        let skySprite01: PIXI.Sprite;
        let skySprite02: PIXI.Sprite;
        let randomNumber: number = -1;
        let previousRandom: number = -1;
        for (let i: number = 0; i < LonerSkyScroller.SKY_POSITIONS.length; i++) {
            while (randomNumber == previousRandom) {
                randomNumber = MathHelper.randomNumberInRange(0, this._skyTextures.length - 1);
            }
            previousRandom = randomNumber;
            skySprite01 = new PIXI.Sprite(this._skyTextures[randomNumber]);
            skySprite01.position = LonerSkyScroller.SKY_POSITIONS[i];
            this._scrollContainer01Sprites.push(skySprite01);
            this._scrollContainer01.addChild(skySprite01);
            this._scrollContainer01TextureNumber.push(randomNumber);
            if (i > 0) {
                skySprite02 = new PIXI.Sprite(this._skyTextures[randomNumber]);
                skySprite02.position = LonerSkyScroller.SKY_POSITIONS[i - 1];
                this._scrollContainer02.addChild(skySprite02);
                this._scrollContainer02TextureNumber.push(randomNumber);
                this._scrollContainer02Sprites.push(skySprite02);
            }
        }

        while (randomNumber == previousRandom) {
            randomNumber = MathHelper.randomNumberInRange(0, this._skyTextures.length - 1);
        }
        this._scrollContainer02TextureNumber.push(randomNumber);
        skySprite02 = new PIXI.Sprite(this._skyTextures[randomNumber]);
        skySprite02.position = LonerSkyScroller.SKY_POSITIONS[LonerSkyScroller.SKY_POSITIONS.length - 1];
        this._scrollContainer02.addChild(skySprite02);
        this._scrollContainer02Sprites.push(skySprite02);

        this.addChild(this._scrollContainer01);
        this._scrollContainer02.visible = false;
        this.addChild(this._scrollContainer02);

        this._scroll01TL = gsap.timeline({paused: true, repeat: 0, onComplete: () => this.onScroll01Complete()});
        this._scroll01TL.add(gsap.to(this._scrollContainer01.position, {
            ease: "none",
            duration: 6,
            x: -302
        }));

        this._scroll02TL = gsap.timeline({paused: true, repeat: 0, onComplete: () => this.onScroll02Complete()});
        this._scroll02TL.add(gsap.to(this._scrollContainer02.position, {
            ease: "none",
            duration: 6,
            x: -302
        }));
    }

    public startScroll(): void {
        if (this._scroll01TL.isActive() || this._scroll02TL.isActive()){
            this._scroll01TL.timeScale(1);
            this._scroll02TL.timeScale(1);
        }else{
            this._scroll01TL.restart();
        }
    }

    public slowScroll(): void {
        this._scroll01TL.timeScale(0.25);
        this._scroll02TL.timeScale(0.25);
    }

    private onScroll01Complete(): void {
        this._scrollContainer01.position.x = 0;
        this._scrollContainer02.visible = true;
        this._scrollContainer01.visible = false;
        this._scroll02TL.restart();
        this._scrollContainer01Sprites[0].texture = this._scrollContainer02Sprites[1].texture;
        this._scrollContainer01Sprites[1].texture = this._scrollContainer02Sprites[2].texture;
        this._scrollContainer01Sprites[2].texture = this._scrollContainer02Sprites[3].texture;
        this._scrollContainer01Sprites[3].texture = this._skyTextures[MathHelper.randomNumberInRange(0, this._skyTextures.length - 1)];
    }

    private onScroll02Complete(): void {
        this._scrollContainer01.position.x = 0;
        this._scrollContainer02.visible = false;
        this._scrollContainer01.visible = true;
        this._scroll01TL.restart();
        this._scrollContainer02Sprites[0].texture = this._scrollContainer01Sprites[1].texture;
        this._scrollContainer02Sprites[1].texture = this._scrollContainer01Sprites[2].texture;
        this._scrollContainer02Sprites[2].texture = this._scrollContainer01Sprites[3].texture;
        this._scrollContainer02Sprites[3].texture = this._skyTextures[MathHelper.randomNumberInRange(0, this._skyTextures.length - 1)];
    }

    public reset():void{

    }
}